export default __webpack_public_path__ + "static/media/music.e5540aa8.jpg";